__turbopack_context__.v({
  "hero": "HeroSection-module__Eq2Jza__hero",
  "heroInner": "HeroSection-module__Eq2Jza__heroInner",
  "heroTitle": "HeroSection-module__Eq2Jza__heroTitle",
});
